/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import actions from '../../../actions';
import ShiftTable from './ShiftTable';
import { withRefreshTableOnFilterChange } from '../common/decorators';
import MobileTableCard from './mobile-card/index';
import history from '../../../history';

@withRefreshTableOnFilterChange
class ShiftManagementSchedule extends Component {
    constructor() {
        super();
        this.state = {
            width: window.innerWidth,
        };
    }

    componentDidMount() {
        const currentUrlParams = new URLSearchParams(history.location.search);
        this.props.load(currentUrlParams);
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };

    render() {
        let pages = -1;
        let showPaginationBottom = false;
        const { width } = this.state;
        const isMobile = width <= 900;
        if (this.props.meta) {
            pages = Math.ceil(this.props.meta.count / 20);
            showPaginationBottom = this.props.meta.count > 20;
        }
        const data = this.props.content ? this.props.content : [];

        const currentUrlParams = new URLSearchParams(history.location.search);

        if (isMobile) {
            return (
                <MobileTableCard
                    data={data}
                    meta={this.props.meta}
                    history={history}
                    user={this.props.user}
                    loading={this.props.fetching}
                    isMobile={isMobile}
                    notification={this.props.notification}
                    onShiftsSelected={this.props.onShiftsSelected}
                    reloadData={() => {
                        this.props.load(currentUrlParams);
                    }}
                />
            );
        }
        return (
            <ShiftTable
                isMobile={isMobile}
                meta={this.props.meta}
                data={data}
                pages={pages}
                loading={this.props.fetching}
                history={history}
                showPaginationBottom={showPaginationBottom}
                onShiftsSelected={this.props.onShiftsSelected}
                user={this.props.user}
                notification={this.props.notification}
                reloadData={() => {
                    this.props.load(currentUrlParams);
                }}
                selectedJobs={this.props.selectedJobs}
                selectedFreelancers={this.props.selectedFreelancers}
                setSelectedJobs={this.props.setSelectedJobs}
                setSelectedFreelancers={this.props.setSelectedFreelancers}
            />
        );
    }
}

const mapStateToProps = state => ({
    ...state.shifts,
    user: state.user,
    selectedJobs: state.shifts.selectedJobs,
    selectedFreelancers: state.freelancers.selectedFreelancers,
});

const mapDispatchToProps = dispatch => ({
    load: searchParams => dispatch(actions.loadShifts(searchParams)),
    onShiftsSelected: selected => dispatch(actions.shiftsSelected(selected)),
    setSelectedJobs: items => dispatch(actions.setSelectedJobs(items)),
    setSelectedFreelancers: items =>
        dispatch(actions.setSelectedFreelancers(items)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ShiftManagementSchedule);
